import i18n from 'translations/i18n'
import { isEmpty } from 'lodash'
import { Flex } from '@jisr-hr/design-system'
import JisrLoader from 'components/global/JisrLoader'
import { Info, DetailsNote, Assignee } from 'components/global/templates/RequestDrawer/components'
import Attachment from 'components/global/templates/RequestDrawer/components/Attachment'
import ReassignTask from 'components/global/templates/RequestDrawer/components/ReassignTask/ReassignTask'
import { statusTypes } from 'utils/uiHelpers'
import { format } from 'utils/date'
import { isTruthy } from 'utils/truthy'
import { useSelector } from 'utils/hooks'
import { ReactComponent as StatusIcon } from '../../icons/status.svg'
import { ReactComponent as CalendarIcon } from '../../icons/calendar.svg'
import { useRequestDetail } from '../../hooks'
import InfoBadge from '../../components/Info/components/InfoBadge'

type AttachmentTypes = {
  name?: string
  size?: number
  url?: string
}

const CustomTask = (): JSX.Element => {
  const { request } = useRequestDetail()
  const { fetching_reassign } = useSelector((state) => state.approvals)

  return (
    <Flex
      flexCol
      style={{ gap: '16px' }}
    >
      {fetching_reassign && <JisrLoader absolute />}
      <Info
        details={request}
        customItems={[
          {
            label: i18n.t('status'),
            icon: <StatusIcon />,
            value: (
              <InfoBadge
                label={request?.status_i18n}
                type={statusTypes[request?.status?.toLowerCase()] || 'gray'}
              />
            ),
            key: 'status',
          },
          {
            label: i18n.t('date'),
            icon: <CalendarIcon />,
            value: format(new Date(request?.created_at), 'dd MMM, yyyy') || '--',
            color: 'var(--color-natural-black-default-new)',
            key: 'date',
          },
          ...(!isEmpty(request.attachments)
            ? request.attachments.map((att: AttachmentTypes, i: number) => ({
                label: i18n.t('attachment'),
                icon: <span />,
                value: (
                  <Attachment
                    name={att?.name}
                    size={att?.size}
                    url={att?.url}
                  />
                ),
                key: i,
              }))
            : []),
        ].filter(isTruthy)}
      />

      {!isEmpty(request.details) && (
        <DetailsNote
          title={i18n.t('description')}
          reason={request.details}
        />
      )}

      <Assignee
        details={{
          assignee: request.assignee,
          status: request.status,
          status_i18n: request.status_i18n,
          time: request?.time,
        }}
      />
      {request?.status === 'Pending' && <ReassignTask />}
    </Flex>
  )
}

export default CustomTask
